module.exports = __webpack_public_path__ + "img/peace-fill.802490e0.svg";